/** 成员类型 */
export enum OUTER_USER_TYPE {
  /** 默认 */
  'DEF' = 0,
  /** 供应商 - SRM */
  'SRM' = 1,
  /** 内部成员 - LeyoKey */
  'LEYOKEY' = 2
}
/** 成员类型选项 */
export const OUTER_USER_TYPE_OPTIONS = [
  { value: OUTER_USER_TYPE.LEYOKEY, label: '内部成员' },
  { value: OUTER_USER_TYPE.SRM, label: '供应商' }
]
/** 成员类型选项 - 所有 */
export const OUTER_USER_TYPE_OPTIONS_ALL = [
  ...OUTER_USER_TYPE_OPTIONS,
  { value: OUTER_USER_TYPE.DEF, label: '默认' }
]

/** 账号的 合作业务类型 */
export enum BUSINESS_TYPE {
  /** 普品 */
  NORMAL = 1,
  /** 首推 */
  FIRST = 2,
  /** YQS */
  CASH_COW = 3,
  /** 集采 */
  GROUP = 4,
  /** 控销 */
  CONTROL = 5
}

/** 编辑账号保存接口入参字段 */
export const UPDATE_ACCOUNT_PARAMS_LIST = [
  'businessTypeArr',
  'id',
  'name',
  'parentId',
  'phone',
  'roleId',
  'supplierCode'
] as const

export type updateAccountParamsListUnion = (typeof UPDATE_ACCOUNT_PARAMS_LIST)[number]
